import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/use-stores';
import TrainingUsersTable from './TrainingUsersTable';
import TrainingUsersHeader from './TrainingUsersHeader';
import { Block } from '@awarego-ui/components';

function TrainingUsersContainer({
    companyId,
    ssoEnabled = false,
    anonymousTracking = false,
    training,
}) {
    const { automationStore, userStore, store } = useStores();
    const { currentCompany } = store;

    const [query, setQuery] = useState({
        p: 0,
        n: 10,
        order: 'name asc',
        filter: '',
    });

    useEffect(() => {
        userStore.setQueryContext({
            n: 10,
            p: 0,
            order: 'name asc',
            filter: '',
        });
    }, []);

    useEffect(() => {
        if (!anonymousTracking && training) {
            automationStore.loadTrainingUsers(companyId, training.id, query);
        }
    }, [automationStore, anonymousTracking, companyId, training, query]);

    const setSearchValue = useCallback((value) => {
        const filter = value || '';
        setQuery((current) =>
            current.filter === filter && current.p === 0
                ? current
                : {
                      ...current,
                      p: 0,
                      filter,
                  }
        );
    }, []);

    const onChangePagingParams = useCallback((p, n) => {
        setQuery((current) =>
            current.p === p && current.n === n ? current : { ...current, p, n }
        );
    }, []);

    const onChangeSort = useCallback((sortBy) => {
        if (!sortBy || sortBy.length === 0) return;
        const order = `${sortBy[0].id} ${sortBy[0].desc ? 'desc' : 'asc'}`;
        setQuery((current) =>
            current.order === order ? current : { ...current, order }
        );
    }, []);

    return (
        <Block gap={24} tablePadding noBorder resetMargin>
            <TrainingUsersHeader
                onSearchValue={setSearchValue}
                users={automationStore.trainingUsers}
                usersTotal={automationStore.trainingUsersTotal}
            />
            {training && (
                <TrainingUsersTable
                    currentCompany={currentCompany}
                    users={automationStore.trainingUsers}
                    usersTotal={automationStore.trainingUsersTotal}
                    loadingUsers={automationStore.loadingTrainingUsers}
                    training={training}
                    ssoEnabled={ssoEnabled}
                    anonymousTracking={anonymousTracking}
                    searchValue={query.filter}
                    pageSize={query.n}
                    onChangePagingParams={onChangePagingParams}
                    onChangeSort={onChangeSort}
                />
            )}
        </Block>
    );
}

export default observer(TrainingUsersContainer);
